import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function VariantPathoText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Do your genetic variants indicate a risk for" 
            headline_grey = "specific hereditary diseases"
            headline_p2 = "?"

            text1 = "This section focuses on your genetic risk for specific hereditary diseases."
            text2 = "We analyze disease-specific panels curated by experts to scan for genetic variants in key genes known to be associated with various conditions that are summarized into disease panels."
            text3 = "This site helps you and your doctor or genetic counselor better understand your hereditary risk and guide any next steps if needed."

            />
    }/>
            
  )
}